import { render, staticRenderFns } from "./CreateBrawlStarsTournament.vue?vue&type=template&id=808fd6a4&scoped=true&lang=pug"
import script from "./CreateBrawlStarsTournament.vue?vue&type=script&lang=js"
export * from "./CreateBrawlStarsTournament.vue?vue&type=script&lang=js"
import style0 from "./CreateBrawlStarsTournament.vue?vue&type=style&index=0&id=808fd6a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808fd6a4",
  null
  
)

export default component.exports